// extracted by mini-css-extract-plugin
module.exports = {"container":"swipeable-card_container__M9Vrk","content":"swipeable-card_content__xllO_","delete":"swipeable-card_delete__6FEA4","animating":"swipeable-card_animating__Evj1G"};